// mirror of auware/.../frontend/src/components/ui/ProgressBar.tsx (see frontend/CLAUDE.md mirror policy).
/**
 * Simple progress bar with configurable size.
 */

interface ProgressBarProps {
  /** Percentage 0 to 100. */
  value: number;
  /** Visual size. */
  size?: "sm" | "md";
}

export default function ProgressBar({ value, size = "md" }: ProgressBarProps) {
  const h = size === "sm" ? "h-1" : "h-2";
  return (
    <div className={`w-full overflow-hidden rounded-full bg-neutral-200 ${h}`}>
      <div
        className={`${h} rounded-full bg-primary-500 transition-all duration-300`}
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  );
}
